var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.pieCountClass},[_c('span',{staticClass:"rating-pie__number"},[_vm._v(" "+_vm._s(_vm.rating || 'N/A')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }